import React from 'react';
import { useChatbot } from '../../hooks/use-chatbot';

export const Chatbot = () => {
  const { chatbotModule, conditionsMet } = useChatbot();

  return conditionsMet ? <>{chatbotModule}</> : null;
};
